import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[mediaDetailDirective]',
})
export class MediaDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}